import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../_components/shared';
import { ImportActionsCard, ExportBdCard } from '../../_components/rcg';

const TABS = { IMPORT: 'import', EXPORT: 'export' };

function AgentGrdfRcg() {
    const [activeTab, setActiveTab] = useState(TABS.IMPORT);

    return (
        <>
            <Header />
            <div className="page">
                <div className="agent-grdf-page">
                    <Link to="/rcg/prestataire-rcg" className="agent-grdf-back-btn">
                        <i className="fas fa-arrow-left" /> Retour
                    </Link>
                    <h2>Administration Agent GRDF</h2>

                    <div className="panel-tabs">
                        <button
                            className={`panel-tab${activeTab === TABS.IMPORT ? ' panel-tab--active' : ''}`}
                            onClick={() => setActiveTab(TABS.IMPORT)}
                        >
                            <i className="fas fa-file-import" />
                            Intégrer un fichier
                        </button>
                        <button
                            className={`panel-tab${activeTab === TABS.EXPORT ? ' panel-tab--active' : ''}`}
                            onClick={() => setActiveTab(TABS.EXPORT)}
                        >
                            <i className="fas fa-file-export" />
                            Exporter la BD
                        </button>
                    </div>

                    {activeTab === TABS.IMPORT && <ImportActionsCard />}
                    {activeTab === TABS.EXPORT && <ExportBdCard />}
                </div>
            </div>
        </>
    );
}

export { AgentGrdfRcg };
